import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cadf96c8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cadf96c8')) {
      api.createRecord('cadf96c8', component.options)
    } else {
      api.reload('cadf96c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cadf96c8&", function () {
      api.rerender('cadf96c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/apiManage/index.vue"
export default component.exports